// import {makeStyles} from '@mui/styles';
/* eslint-disable */

const LightTheme = {
    palette: {
        primary: {
          light: '#757ce8',
          main: '#3174d8',
          dark: '#002884',
          contrastText: '#fff',
        },

        secondary: {
          light: '#d4e2f7',
          main: '#a9c5ef',
          dark: '#7ea8e7',
          contrastText: '#000',
        },
    },
    
    typography: {
        fontSize: 14,
        htmlFontSize: 10,
    },

    // spacing: 4,
    
    components: {
        MuiBox: {
            variants: [{
                props: { 
                    variants: 'dashboard-err', color: 'primary'
                },
                style: ({ ownerState, theme }) => ({
                    backgroundColor: theme.palette.text.secondary,
                    color: theme.palette.primary.contrastText
                })
            }],
        }
        // MuiButton: {
        //     // variants: [{
        //     //     props: { 
        //     //         variants: 'special', color: 'primary'
        //     //     },
        //     //     style: ({ ownerState, theme }) => ({
        //     //         backgroundColor: theme.palette.primary.main,
        //     //         color: theme.palette.primary.contrastText,
        //     //         '&:hover': {
        //     //             backgroundColor: theme.palette.primary.dark,
        //     //         },
        //     //     })
        //     // }],

        //     styleOverrides: {
        //         root: {
        //         },
        //     },
        // },
    }
};


const Styles = {

    paper: {
        padding: '1.5em',
        marginBottom: '1em',
        fontSize: '1.6rem'
    },


    section: {
        // padding: '10px',
        margin: '0.5em',
        marginBottom: '2em'
    },


    sectionTitle: {
        borderBottom: '1px solid #e0e0e0',
        color: '#444',
        fontSize: '1.6rem',
        fontWeight: 'bold',
        marginBottom: '0.8em',
        padding: '0.5em 0 0.3em 0.6em'
    },


    toolbarButton: {
        fontSize: '1.2rem',
    },


    propertyFieldLabel: {
        // borderBottom: 'none',
        padding: '0.25em 1em 0.25em 0',
        textAlign: 'right',
        width: '10em',
        fontSize: '1.6rem'
    },


    propertyFieldValue: {
        // borderBottom: 'none',
        padding: '0.25em 1em 0.25em 0',
        verticalAlign: 'middle',
        width: '30em', 
        fontSize: '1.6rem'
    },


    propertyDetailLabel: {
        width: '10em', 
        fontSize: '1.5rem',
        borderBottom: 'none',
    },


    propertyDetailValue: {
        fontSize: '1.5rem',
        borderBottom: 'none',
    },


    adminFwUpdateSubsection: {
        marginTop: '1.5em'
    },

    adminFwUpdateSubsectionContent: {
        marginLeft: '1.5em'
    },

    adminRebootContent: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },


    adminRebootContentElem: {
        marginLeft: '1em',
        marginRight: '1em',
    },

    adminLicenseSubsectionContent: {
        marginLeft: '1.5em'
    },

    scannerTestSingleImageContainer: {
        backgroundColor: '#F5F4F2',
        boxShadow: 5,
        margin: '2em',
        padding: '1em',
        borderRadius: 2,
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative'
    },

    scannerSingleTestImage: {
        boxSizing: 'border-box',
        padding: '1em',
        width: '100%',
        objectFit: 'contain'
    },

    scannerTestSingleItemInfo: {
        paddingLeft: '1.5em',
        paddingRight: '1.5em',
        paddingTop: '0.5em',
        fontSize: '1.8rem',
    },

    irnText: {
        fontWeight: 900,
        fontFamily: 'monospace',
        letterSpacing: '0.15em'
    },

    codelineText: { 
        fontSize: '2.4rem',
        fontWeight: 900,
        fontFamily: 'MICR-E13B',
        letterSpacing: '0.08em',
        '&:hover': {
          fontSize: '1.8rem',
          fontWeight: 900,
          fontFamily: 'monospace',
          letterSpacing: '0.15em'
        },
    },

    scannerTrackContainer: {
        // fontWeight: 900,
        fontFamily: 'monospace',
        // letterSpacing: '0.15em',
        backgroundColor: '#F5F4F2',
        boxShadow: 5,
        margin: '2em',
        padding: '1em',
        borderRadius: 2,
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative'
    },

}


export {Styles, LightTheme};
